import { NetworkPublicInfoFields } from '@tribeplatform/gql-client/graphql'
import type { NetworkPublicInfo } from '@tribeplatform/gql-client/types'

import { useQuery, UseQueryOptions } from '../../lib/react-query/useQuery.js'
import { useTribeClient } from '../../useTribeClient.js'
import { getWorkspacesKey } from '../../utils/keys/workspaces.key.js'

export const useWorkspaces = (options?: {
  useQueryOptions?: UseQueryOptions<NetworkPublicInfo[]>
  fields?: NetworkPublicInfoFields
}) => {
  const { useQueryOptions, fields = 'basic' } = options || {}
  const { client } = useTribeClient()
  const workspacesKey = getWorkspacesKey({ fields })

  return useQuery<NetworkPublicInfo[]>(
    workspacesKey,
    () => client.getWorkspaces(fields),
    {
      ...useQueryOptions,
    },
  )
}
